import React from "react";

const DisplayObject = ({ data }) => {

  //  Handle null / NA
  if (data === null || data === undefined || data === "N/A" || data === "NA") {
    return <span>{data}</span>;
  }

  let parsedData = data;

  //  Normalize Python-style string → JSON
  if (typeof data === "string") {
    try {
      const normalized = data
        .replace(/'/g, '"')
        .replace(/\bNone\b/g, "null");

      parsedData = JSON.parse(normalized);
    } catch (err) {
      return <span>{data}</span>;
    }
  }

  //  If not object
  if (typeof parsedData !== "object" || Array.isArray(parsedData)) {
    return <span>{String(parsedData)}</span>;
  }

  //  Render object safely
  return (
    <div>
      {Object.entries(parsedData).map(function ([key, value]) {
        const formattedKey = key
          .replace(/_/g, " ")
          .replace(/\b\w/g, function (char) {
            return char.toUpperCase();
          });

        return (
          <p key={key} style={{ margin: "0" }}>
            <strong>{formattedKey}:</strong>{" "}
            {value !== null && value !== undefined ? String(value) : ""}
          </p>
        );
      })}
    </div>
  );
};

export default DisplayObject;
